
<div class="flow-emoji-picker-wrapper" :inline="inline" @click="handleClick">
	<PopOver :open.sync="openPicker" :overlay="false">
		<div
			class="flow-emoji-selected"
			tabindex="-1"
			:effects="effects"
			:state="state"
			:data-placeholder="selectedHtml ? '' : placeholder"
			@click="openPicker = true"
		>
			<span>{{ selectedHtml }}</span>
			<Icon
				v-if="selectedHtml !== '' && selectedHtml !== null && selectedHtml !== undefined"
				name="i-close"
				type="filled"
				:effects="false"
				size="x-small"
				@click.stop="handleSelect(null)"
			/>
			<Icon
				v-if="state === 'error'"
				:state="'error'"
				:size="'small'"
				:effects="false"
				name="i-info-fill"
				type="filled"
			/>
		</div>

		<template #content>
			<div class="flow-emoji-picker">
				<Picker
					:title="title"
					:native="true"
					:include="include"
					:exclude="exclude"
					:custom="custom"
					:emoji="'point_up'"
					:recent="recent"
					@select="handleSelect"
					@skin-change="handleSkinChange"
				/>
			</div>
		</template>
	</PopOver>
</div>
